export default __webpack_public_path__ + "static/Calibre-Light-747b2e5e6d3f057e2b1271fb3062df4a.ttf";